import DOMPurify from 'dompurify'

const ALLOWED_TAGS = ['b', 'i', 'em', 'strong', 'u', 'sup', 'sub', 'code']

export default function SafeHtml({ html, className }) {
  const clean = DOMPurify.sanitize(html ?? '', { ALLOWED_TAGS })
  return <span className={className} dangerouslySetInnerHTML={{ __html: clean }} />
}
